import React from 'react';
import { faBan, faBook, faShieldCheck, faTruck } from '@fortawesome/pro-light-svg-icons';

import Feature from './Feature';

export default function WhyDiscountMags() {
  return (
    <div className="border-[1.5px] border-gray-300 rounded-md p-5 mb-10 lg:mb-12 relative">
      <div className="absolute -top-4 inset-x-0 flex items-center justify-center">
        <h2 className="text-lg inline-block font-bold bg-white px-4">Why choose DiscountMags?</h2>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-6 pt-3">
        <Feature icon={faBook} text="1,000,000+ Magazines & Books" />
        <Feature icon={faBan} text="No Hidden Fees" />
        <Feature icon={faTruck} text="Free Shipping for Magazines" />
        <Feature icon={faShieldCheck} text="Satisfaction Guaranteed" />
      </div>
    </div>
  );
}
